import { render, staticRenderFns } from "./GebrauchtwagenMultiItem.vue?vue&type=template&id=880f4f7a&scoped=true&slot=header&"
import script from "./GebrauchtwagenMultiItem.vue?vue&type=script&lang=js&"
export * from "./GebrauchtwagenMultiItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880f4f7a",
  null
  
)

export default component.exports